import { render, staticRenderFns } from "./CardVesselInfo.vue?vue&type=template&id=e6b87da8"
import script from "./CardVesselInfo.vue?vue&type=script&lang=js"
export * from "./CardVesselInfo.vue?vue&type=script&lang=js"
import style0 from "./CardVesselInfo.vue?vue&type=style&index=0&id=e6b87da8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports